import ky from 'ky-universal';
import Cookies from 'js-cookie';

import { AUTH_TOKEN } from '@/api/constants';
import { kyAfterResponse, kyBeforeError } from './hooks';

const apiUrl = process.env.API_URL;
const baseUrl = process.env.BASE_URL;
const ssoUrl = process.env.SSO_URL;

const request = ky.extend({
    prefixUrl: apiUrl,
    hooks: {
        beforeRequest: [
            r => {
                const token = Cookies.get(AUTH_TOKEN);
                if (token) {
                    r.headers.set('Authorization', `Bearer ${token}`);
                }
                r.headers.set('Content-Type', 'application/json');
            },
        ],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
    timeout: Number(process.env.HTTP_TIMEOUT) || 30000,
});

export const requestWithoutAuth = ky.extend({
    prefixUrl: apiUrl,
    hooks: {
        beforeRequest: [
            r => {
                r.headers.set('Content-Type', 'application/json');
            },
        ],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
    timeout: Number(process.env.HTTP_TIMEOUT) || 30000,
});

export const ssoRequest = ky.extend({
    // prefixUrl: ssoUrl,
    hooks: {
        beforeRequest: [
            r => {
                // const token = Cookies.get(AUTH_TOKEN);
                // r.headers.set('Authorization', token ? `Bearer ${token}` : null);
                r.headers.set('Content-type', 'application/json');
            },
        ],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
    afterResponse: [
        async (request, options, response) => {
            if (response.status === 404 && response.error) {
                return alert(`${JSON.stringify(response.error)}`);
            }
        },
    ],
    credentials: 'include',
    timeout: Number(process.env.HTTP_TIMEOUT) || 30000,
});

export const requestFile = ky.extend({
    prefixUrl: baseUrl,
    hooks: {
        beforeRequest: [
            r => {
                const token = Cookies.get(AUTH_TOKEN);
                r.headers.set('Authorization', token ? `Bearer ${token}` : null);
                // r.headers.set('Content-type', 'application/json');
            },
        ],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
    timeout: Number(process.env.HTTP_TIMEOUT) || 30000,
});

export const requestMediaFile = ky.extend({
    hooks: {
        beforeRequest: [],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
    timeout: Number(process.env.HTTP_TIMEOUT) || 30000,
});

export const requestFormData = ky.extend({
    prefixUrl: apiUrl,
    hooks: {
        beforeRequest: [
            r => {
                const token = Cookies.get(AUTH_TOKEN);
                r.headers.set('Authorization', token ? `Bearer ${token}` : null);
            },
        ],
        afterResponse: [kyAfterResponse],
        beforeError: [kyBeforeError],
    },
});

export default request;
